const DEFAULT_CONNECTION_ERROR = "Erreur de connexion. Veuillez vérifier votre connexion internet et réessayer.";
const DEFAULT_CREATION_ERROR = "Une erreur est survenue lors de la création de la carte de fidélité";
const DEFAULT_GENERIC_ERROR = "Une erreur est survenue";
const DEFAULT_SERVER_ERROR = "Le serveur rencontre des difficultés temporaires. Veuillez réessayer dans quelques minutes ou contacter le support client si le problème persiste.";

const ERROR_MESSAGES = {
  100: "Utilisateur introuvable. Veuillez vous reconnecter.",
  101: "Le nom de famille est requis.",
  102: "Le prénom est requis.",
  103: "La civilité est requise.",
  104: "Cette adresse email est déjà utilisée.",
  105: "Le format de l'email n'est pas valide.",
  108: "Le format de la date de naissance n'est pas correct.",
  109: "La date de naissance n'est pas valide.",
  110: "Veuillez sélectionner un magasin.",
  113: "Le numéro de téléphone n'est pas valide.",
  140: "Les informations ne correspondent pas à votre carte. Veuillez contacter le service client.",
  500: "Erreur serveur interne. Veuillez réessayer plus tard ou contacter le support client.",
  502: "Service temporairement indisponible. Veuillez réessayer dans quelques minutes.",
  503: "Service en maintenance. Veuillez réessayer plus tard.",
  504: "Délai d'attente dépassé. Veuillez réessayer.",
  999: "Une erreur interne s'est produite."
};

const hasValidResponseData = (error) => {
  return error?.response?.data;
};

const extractBackendErrorMessage = (errorData) => {
  if (errorData.erreurs?.length > 0) {
    const backendError = errorData.erreurs[0];
    return backendError.message || DEFAULT_GENERIC_ERROR;
  }
  return null;
};

const extractDirectErrorMessage = (errorData) => {
  return errorData.message || null;
};

export const extractErrorMessage = (error) => {
  const status = error.response?.status;
  
  if (status >= 500) {
    return getCustomErrorMessage(status) || DEFAULT_SERVER_ERROR;
  }
  
  if (status === 404) {
    return "Service non trouvé. Veuillez contacter le support client.";
  }
  
  if (status === 403) {
    return "Accès refusé. Veuillez vous reconnecter.";
  }
  
  if (status === 401) {
    return "Session expirée. Veuillez vous reconnecter.";
  }

  if (!hasValidResponseData(error)) {
    return DEFAULT_CONNECTION_ERROR;
  }

  const errorData = error.response.data;

  return extractBackendErrorMessage(errorData) ||
         extractDirectErrorMessage(errorData) ||
         DEFAULT_CREATION_ERROR;
};

export const getCustomErrorMessage = (errorCode) => {
  return ERROR_MESSAGES[errorCode] || null;
};